import { Button, Form } from "react-bootstrap";
import parse from 'html-react-parser';
import { Video } from "../../interfaces/Video";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Overlay } from "../../elements/Overlay";

export interface VideoDeleteProps {
    video: Video;
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function VideoDelete(props: VideoDeleteProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();
    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const requestOptionsDelete = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        };
        fetch(import.meta.env.VITE_API_URL + '/v1/video-tutorials/' + props.video._id, requestOptionsDelete)
            .then(response => {
                props.submitCallback(props.video._id);
            })
            .catch((error => {
                navigate('/');
            }));
    }

    return(
        <Overlay title={t("Delete Video")} onClose={handleClose} className="admin-delete-video-container">
            <Form onSubmit={ handleSubmit }>
                <Form.Text id="deleteConfirmationMessage">
                    { parse(t("You are about to delete Video content") + ' ' + '<strong>' + props.video.title + '</strong>. ' +
                        t("This action cannot be undone.") + ' ' +
                        t("Are you sure you want to proceed?"))
                    }
                </Form.Text>
                <div className="actions">
                    <Button variant="primary" type="submit">{ t("Yes") }</Button>
                    <Button variant="secondary" onClick={ handleClose }>{ t("No") }</Button>
                </div>
            </Form>
        </Overlay>
    );
}